var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGridViewless({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "grid view 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "grid-view-1",
    fill: "#727272",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.2,0 L1.8,0 C0.81,0 0,0.81 0,1.8 L0,16.2 C0,17.19 0.81,18 1.8,18 L16.2,18 C17.19,18 18,17.19 18,16.2 L18,1.8 C18,0.81 17.19,0 16.2,0 Z M8,10 L8,16 L3.5,16 C2.675,16 2,15.325 2,14.5 L2,10 L8,10 Z M16,10 L16,14.5 C16,15.325 15.325,16 14.5,16 L10,16 L10,10 L16,10 Z M8,8 L2,8 L2,3.5 C2,2.675 2.675,2 3.5,2 L8,2 L8,8 Z M16,8 L10,8 L10,2 L14.5,2 C15.325,2 16,2.675 16,3.5 L16,8 Z",
    id: "Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGridViewless);
export default __webpack_public_path__ + "static/media/grid_viewless.0f9781d43035bcd4aa125edc8d5d0bab.svg";
export { ForwardRef as ReactComponent };